import { Box, Button, Heading, Text } from '@zillow/constellation-10';
import type { UserStatus } from '../../../graphql/queries';
import { BackgroundReportAlertSmall, isBackgroundCheckViewable } from '../BackgroundReport/BackgroundReportAlert';
import { getIsBackgroundReportValid } from '../../../utils/user-statuses';
import type { BackgroundReport } from '@zg-rentals/ts-capps-client';

export function BackgroundReportOverview({
  backgroundReport,
  userStatuses,
  onView,
}: {
  backgroundReport?: BackgroundReport;
  userStatuses: Array<UserStatus>;
  onView: () => void;
}) {
  const isBackgroundReportValid = getIsBackgroundReportValid(userStatuses);
  const backgroundReportVisible = isBackgroundCheckViewable(backgroundReport);

  const evictionCount = backgroundReport?.evictionReport?.records
    ? backgroundReport?.evictionReport?.records.length
    : '0';
  const criminalCount = backgroundReport?.criminalReport?.records
    ? backgroundReport?.criminalReport?.records.length
    : '0';

  return (
    <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
        <Heading level={2} textStyle="responsive.heading-sm">
          Background check
        </Heading>
        <BackgroundReportAlertSmall backgroundReport={backgroundReport} />

        <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'default' }}>
          <Box css={{ gridColumnEnd: 'span 2', md: { gridColumnEnd: 'span 1' } }}>
            <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
              <Heading level={3} textStyle="responsive.heading-xs" css={{ color: 'text.subtle' }}>
                {Number(evictionCount) === 1 ? 'Housing court record' : 'Housing court records'}
              </Heading>
              <Text>
                <strong>{isBackgroundReportValid && backgroundReportVisible ? evictionCount : '-'}</strong>
              </Text>
            </Box>
          </Box>
          <Box css={{ gridColumnEnd: 'span 2', md: { gridColumnEnd: 'span 1' } }}>
            <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
              <Heading level={3} textStyle="responsive.heading-xs" css={{ color: 'text.subtle' }}>
                {Number(criminalCount) === 1 ? 'Criminal record' : 'Criminal records'}
              </Heading>
              <Text>
                <strong>{isBackgroundReportValid && backgroundReportVisible ? criminalCount : '-'}</strong>
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
      <Button
        size="sm"
        onClick={onView}
        disabled={!isBackgroundReportValid || !backgroundReportVisible}
        aria-label="View background check"
      >
        View
      </Button>
    </Box>
  );
}
